import React, { Component } from 'react';
import imgbkg from '../../assets/EPSInfographic.jpg';
import './index.css';
import {
  Card,
  CardBody,
  MediaBlock,
  MediaBlockBody,
  MediaBlockBodyHeadline,
  MediaBlockBodyDescription,
  MediaBlockMedia,
  LinkList,
  LinkListItem,
  LocationArrowIcon,
  DatabaseIcon,
  Grid,
  GridItem
} from '@emorg-prd/react-standard';

export default class HomePage extends Component {
  render() {
    return (
      <div className='homepage-tiles'>
        <img src={imgbkg} className='imgbkg' alt='imgbkg' />
        <div>
          <Grid>
            <GridItem className='homepage-grid-item'>
              <Card>
                <CardBody>
                  <MediaBlock size='small'>
                    <MediaBlockMedia></MediaBlockMedia>
                    <MediaBlockBody>
                      <LocationArrowIcon size='large' />
                      <MediaBlockBodyHeadline>
                        Location Data Management
                      </MediaBlockBodyHeadline>
                      <MediaBlockBodyDescription></MediaBlockBodyDescription>
                    </MediaBlockBody>
                  </MediaBlock>
                  <LinkList icons>
                    <a href='newlocation'>
                      <LinkListItem> Create New Location </LinkListItem>
                    </a>
                    <a href='searchLocation'>
                      <LinkListItem> Manage Location </LinkListItem>
                    </a>
                    <a href='searchSite'>
                      <LinkListItem> Manage Site </LinkListItem>
                    </a>
                    <LinkListItem> View Locations (*Coming Soon*)</LinkListItem>
                  </LinkList>
                </CardBody>
              </Card>
            </GridItem>

            {/* <GridItem className='homepage-grid-item'>
              //TODO:::::  **uncomment css class for this card**
              <Card>
                <CardBody>
                  <MediaBlock size='small'>
                    <MediaBlockMedia></MediaBlockMedia>
                    <MediaBlockBody>
                      <MapWPinIcon size='large' />
                      <MediaBlockBodyHeadline>Map+</MediaBlockBodyHeadline>
                      <MediaBlockBodyDescription></MediaBlockBodyDescription>
                    </MediaBlockBody>
                  </MediaBlock>
                  <LinkList icons>
                    <a href='/'>
                      <LinkListItem>
                        Manage Real Estate Optimization (REO) (*Coming Soon*)
                      </LinkListItem>
                    </a>
                    <a href='/'>
                      <LinkListItem>Map+ (*Coming Soon*)</LinkListItem>
                    </a>
                  </LinkList>
                </CardBody>
              </Card>
            </GridItem> */}

            <GridItem className='homepage-grid-item'>
              <Card>
                <CardBody>
                  <MediaBlock size='small'>
                    <MediaBlockMedia></MediaBlockMedia>
                    <MediaBlockBody>
                      <DatabaseIcon size='large' />
                      <MediaBlockBodyHeadline>
                        Behind the Scenes
                      </MediaBlockBodyHeadline>
                      <MediaBlockBodyDescription></MediaBlockBodyDescription>
                    </MediaBlockBody>
                  </MediaBlock>
                  <LinkList icons>
                    <a href='https://eps-mmt.xom.cloud/'>
                      <LinkListItem> Metadata Management Tool </LinkListItem>
                    </a>
                    {/* TODO: FILL OUT THESE LINKS WHEN AVAILALBE */}
                    <a href='/'>
                      <LinkListItem> Data Job Schedule (*Coming Soon*)</LinkListItem>
                    </a>
                    <a href='/'>
                      <LinkListItem>
                        Location Data Landscape (*Coming Soon*)
                      </LinkListItem>
                    </a>
                  </LinkList>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </div>
      </div>
    );
  }
}
